import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const LINKS = [
  { id: "about", label: "About" },
  { id: "impact", label: "Impact" },
  { id: "experience", label: "Experience" },
  { id: "principles", label: "Principles" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    if (pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 500);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const home = () => {
    if (pathname !== "/") navigate("/");
    else window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <header
      data-testid="main-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 ${
        scrolled || pathname !== "/"
          ? "bg-black/60 backdrop-blur-2xl border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 h-20 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={home}
          className="font-display text-lg tracking-tight text-white hover:text-[#c9a24e] transition-colors"
        >
          Naresh Gabriel<span className="text-[#c9a24e]">.</span>
        </button>
        <nav className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => go(l.id)}
              className="group relative text-[13px] uppercase tracking-[0.2em] text-[#a1a1aa] hover:text-white transition-colors"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-[#c9a24e] transition-all duration-300 group-hover:w-full" />
            </button>
          ))}
          <button
            data-testid="nav-gallery"
            onClick={() => navigate("/gallery")}
            className={`group relative text-[13px] uppercase tracking-[0.2em] transition-colors ${
              pathname === "/gallery" ? "text-[#c9a24e]" : "text-[#a1a1aa] hover:text-white"
            }`}
          >
            Gallery
            <span className="absolute -bottom-1 left-0 h-px w-0 bg-[#c9a24e] transition-all duration-300 group-hover:w-full" />
          </button>
        </nav>
        <button
          data-testid="nav-cta"
          onClick={() => go("contact")}
          className="hidden sm:inline-flex items-center border border-white/20 px-5 py-2 text-[12px] uppercase tracking-[0.2em] text-white hover:bg-[#c9a24e] hover:text-black hover:border-[#c9a24e] transition-colors"
        >
          Get in touch
        </button>
      </div>
    </header>
  );
};
